import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form } from "antd";
import { FormContentBlockerFieldIsVisual } from "./isVisual.js";
import { FormContentBlockerFieldIsVisualDarkMode } from "./isVisualDarkMode.js";
import { FormContentBlockerFieldShouldForceToShowVisual } from "./shouldForceToShowVisual.js";
import { FormContentBlockerFieldVisualBlur } from "./visualBlur.js";
import { FormContentBlockerFieldVisualContentType } from "./visualContentType.js";
import { FormContentBlockerFieldVisualDownloadThumbnail } from "./visualDownloadThumbnail.js";
import { FormContentBlockerFieldVisualHeroButtonText } from "./visualHeroButtonText.js";
import { FormContentBlockerFieldVisualMediaThumbnail } from "./visualMediaThumbnail.js";
import { FormContentBlockerFieldVisualType } from "./visualType.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormHeadline } from "../../../headline.js";
import { FormContentBlockerLayout } from "../../../layout.js";
const FormContentBlockerFieldVisualCompose = ({ visualMediaThumbnailPicker })=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.criteria !== nextValues.criteria,
        children: ({ getFieldValue })=>{
            const criteria = getFieldValue("criteria");
            return criteria === "services" && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(FormHeadline, {
                        offset: FormContentBlockerLayout.labelCol.span,
                        description: __("For each content blocker it can be defined if it should be visually visible. This means that if the user has not agreed to the respective services, a box with a button is displayed to adjust the privacy settings so that the actual content can be loaded. The design of the box is copied from the cookie banner."),
                        children: __("Visual")
                    }),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldIsVisual, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualType, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualContentType, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldIsVisualDarkMode, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualDownloadThumbnail, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualMediaThumbnail, {
                        children: visualMediaThumbnailPicker
                    }),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualBlur, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualHeroButtonText, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldShouldForceToShowVisual, {})
                ]
            });
        }
    });
};
export { FormContentBlockerFieldVisualCompose };
